module.exports = "/images/everestMasthead_v2.png?e391dafd6f94592fe69e4ac6b1da79a7";